import Return from '../views/return/Index.vue';
import { checkauth } from '../Helper';

const ReturnCreate = () => import('../views/return/Create.vue');
const ReturnEdit = () => import('../views/return/Edit.vue');

function auth(to, from, next) {
	checkauth().then(response => {
		if (response) {
			next();
		} else {
			next('/login');
		}
	});
}

export default [
	{
		path: '/returns',
		name: 'returns',
		component: Return,
		beforeEnter: auth,
	},
	// inserimento e modifica: pagine, non piu' finestre della lista
	{
		path: '/returns/new',
		name: 'return-new',
		component: ReturnCreate,
		beforeEnter: auth,
	},
	{
		path: '/returns/:id([0-9a-fA-F]{24})',
		name: 'return-edit',
		component: ReturnEdit,
		beforeEnter: auth,
	},
];
